import { Button } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import * as React from 'react';
import { useState } from 'react';
import api from '../../../api';
import { IEventV2 } from '../../../data/entities/event';
import { Paragraph } from '../paragraph/Paragraph';

interface IConfirmBookingModalProps {
	event: IEventV2;
	onRequestClose: () => any;
}

export const ConfirmBookingModal: React.FC<IConfirmBookingModalProps> = (props) => {
	const { event, onRequestClose } = props;
	const [processing, setProcessing] = useState(false);
	const [isError, setIsError] = useState(false);
	const comments = [
		'Booking confirmation, to the owner',
		'Booking confirmation, to the guest',
		'First booking, to the owner when necessary'
	];

	const onConfirm = () => {
		setProcessing(true);
		api.availabilityV3.maunallyConfirmBooking(event.property_id, event.id)
			.then(() => {
				setProcessing(false);
				setIsError(false);
				window.location.reload();
			})
			.catch((err) => {
				setProcessing(false);
				setIsError(true);
			});
	};

	return <Modal
		title={`Confirm booking`}
		shouldCloseOnOverlayClick={true}
		onRequestClose={onRequestClose}
		actionRHS={
			<Button
				id={`confirm_booking`}
				onClick={onConfirm}
				bgColor={theme.colours.success.default}
				color={theme.colours.text.light}
				loading={processing}
			>
				{`Confirm booking`}
			</Button>}
	>
		<div className="payment-processing__content">
			<Paragraph>Confirming the booking will send the following emails:</Paragraph>
			<ul>
				{comments.map((comment, idx) => <li key={idx}>{comment}</li>)}
			</ul>
			<Paragraph>These will appear in the notes once they have been sent.</Paragraph>
			<Paragraph>Are you sure you want to confirm this booking?.</Paragraph>
			{processing ? <Paragraph><span className="booking-payment-internal__text-highlight">Confirming booking ...</span>
			</Paragraph> : null}
			{isError && <Paragraph>
				<span className="booking-payment-internal__text-highlight">Something went wrong. Unable to confirm booking.</span>
			</Paragraph>}
		</div>
	</Modal>;
};
